import { render } from "./HeroiconsOutlinePrinter.vue?vue&type=template&id=77ee8f86"
const script = {}

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePrinter.vue"]])

export default __exports__